<template>
  <div>
    <base-header/>
      <router-view class="content"/>
    <base-footer/>
  </div>
</template>

<script>
import BaseHeader from '@/components/Base/Header';
import BaseFooter from '@/components/Base/Footer';

export default {
  name: 'base-main',
  components: {
    BaseHeader,
    BaseFooter,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Base/Main.vue